import React from 'react';
import { Container, Button} from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import ServiceProviderCard from './ServiceProviderCard';
import InvitationSection from './InvitationSection';
import PortalNewsSection from './PortalNewsSection';
import FAQSection from './FAQSection';
import InfoCardsSection from './InfoCardsSection';
import CTASection from './CTASection';

const MainContent = ({state, onLogin}) => {
  return (
    <Container as="main" className="main-content">
      {/* Hero Section */}
      <section className="hero-section">
        <h1>Запишіть дитину до дитячого садочка</h1>
        <p className="lead">
          Портал дошкільної освіти міста Києва — це централізована платформа для батьків, які шукають дитячий садок для своєї дитини. Тут ви можете знайти інформацію про доступні заклади дошкільної освіти, подати заяву на зарахування та отримати необхідні адміністративні послуги у сфері дошкільної освіти
        </p>
              {state === "authsuccess" ? <Button variant="primary" href="profile" size="lg" >Подати заявку</Button> : <Button variant="primary" onClick={onLogin} size="lg" >Подати заявку</Button>  }
        <p className="sub-text"><HashLink smooth to="#questionauth" style={{textDecoration: 'none', color:'#0068FF'}}>Як увійти до Системи?</HashLink></p>
      </section>

      <ServiceProviderCard />
      <InvitationSection />
      <FAQSection />
      <InfoCardsSection />
      <PortalNewsSection />
      <CTASection state={state} onLogin={onLogin}/>
    </Container>
  );
};

export default MainContent;